import React from 'react'
import ProfileHeader from './ProfileHeader'

import { FaUser, FaTools } from 'react-icons/fa'
import { ImKey } from 'react-icons/im'
import ProfileContent from './ProfileContent'

const Profile = (props) => {
  return (
    <div>
        <ProfileHeader />

        <div className="account__nav">
            <p onClick={props.toggle} className='account__active'><FaUser />&nbsp;My Profile</p>
            <p onClick={props.toggleApi} className=''><ImKey />&nbsp;API Token</p>
            <p onClick={props.toggleWebhook} className=''><FaTools />&nbsp;Webhook Config</p>
        </div>

        <ProfileContent />
    </div>
  )
}

export default Profile